import giftCodeIndexPage from './gift-code-index-page.mjs';
import messageTemplateIndexPage from './message-template-index-page.mjs';
import initUsersIndexPage from './users-index-page.mjs';


giftCodeIndexPage();
messageTemplateIndexPage();
initUsersIndexPage();
